import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { cn } from "@/shared/lib/utils";

const PageTransition = ({
  children,
  wrapperClassName,
}: {
  children: React.ReactNode;
  /** Ex.: altura total no modo redação tela cheia (encadeia flex com o main). */
  wrapperClassName?: string;
}) => {
  const { pathname } = useLocation();
  const [transitionState, setTransitionState] = useState<"enter" | "exit">("enter");
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      prevPathname.current = pathname;
      setTransitionState("exit");
      const timeout = setTimeout(() => {
        setTransitionState("enter");
      }, 150);
      return () => clearTimeout(timeout);
    }
  }, [pathname]);

  return (
    <div
      className={cn(
        "transition-all duration-200 ease-out",
        transitionState === "enter" ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2",
        wrapperClassName,
      )}
    >
      {children}
    </div>
  );
};

export default PageTransition;
